"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.usePrivate = exports.PrivateContextProvider = void 0;

var _react = _interopRequireWildcard(require("react"));

var _routerContext = require("./router-context");

const PrivateContext = /*#__PURE__*/(0, _react.createContext)(undefined);

const PrivateContextProvider = ({
  children,
  isPrivate,
  role,
  unauthenticated
}) => {
  const routerState = (0, _routerContext.useRouterState)();
  const {
    isAuthenticated,
    hasRole
  } = routerState.useAuth();
  const unauthorized = (0, _react.useCallback)(() => {
    return !(isAuthenticated && (!role || hasRole(role)));
  }, [isAuthenticated, role, hasRole]);
  return /*#__PURE__*/_react.default.createElement(PrivateContext.Provider, {
    value: {
      isPrivate,
      unauthorized,
      unauthenticated
    }
  }, children);
};

exports.PrivateContextProvider = PrivateContextProvider;

const usePrivate = () => {
  const context = (0, _react.useContext)(PrivateContext);
  const unauthorized = context ? context.unauthorized : () => true;
  const unauthenticated = context ? context.unauthenticated : '';
  return {
    isPrivate: !!(context !== null && context !== void 0 && context.isPrivate),
    unauthorized,
    unauthenticated
  };
};

exports.usePrivate = usePrivate;